import lazyLoading from "./lazyLoading";

export default {
  name: "izvjestaj",
  path: "/obrada/izvjestaj",
  component: lazyLoading("obrada/izvjestaj"),
  meta: {
    default: true,
    title: "Predračun",
    class: "primary",
    show: false,
    iconClass: "fa fa-credit-card",
    requiredAuth: true
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/menu/izvjestaj.js